export enum ApplicationModalStep {
    APPLICATION_FORM_STANDARD,
    NOTIFICATION_CONSENT,
    SUCCESS_INFO,
    GOODBYE_INFO,
    MULTILEAD,
    CLOSE,
    WAITING,
    APPLICATION_FORM_FULL_OFFER,
    APPLICATION_FORM_WITH_NEGOTIATION,
    APPLICATION_FORM_WITH_TOPIC,
    PROMOTION_FORM,
    PROMOTION_PHONE_VERIFICATION,
    PROMOTION_AUTH_FALLBACK,
    PROMOTION_SUBMITTING,
    PROMOTION_SUCCESS,
    HOME_MATCH_BASIC_PREFERENCES
}
export enum ApplicationModalStep {
    APPLICATION_FORM_STANDARD,
    NOTIFICATION_CONSENT,
    SUCCESS_INFO,
    GOODBYE_INFO,
    MULTILEAD,
    CLOSE,
    WAITING,
    APPLICATION_FORM_FULL_OFFER,
    APPLICATION_FORM_WITH_NEGOTIATION,
    APPLICATION_FORM_WITH_TOPIC,
    PROMOTION_FORM,
    PROMOTION_PHONE_VERIFICATION,
    PROMOTION_AUTH_FALLBACK,
    PROMOTION_SUBMITTING,
    PROMOTION_SUCCESS,
    HOME_MATCH_BASIC_PREFERENCES
}
